//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.17.0.0 (NJsonSchema v10.8.0.0 (Newtonsoft.Json v10.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

export class ApiClientBase {
  private readonly config: IApiClientConfig;

  protected constructor(config: IApiClientConfig) {
    this.config = config;
  }

  protected transformOptions = (options: RequestInit): Promise<RequestInit> => {
    this.config.applyTransformToRequest(options);
    return Promise.resolve(options);
  };
}

export interface IWebsiteApiClient {

    /**
     * @return The OK response
     */
    campaignPromoted(): Promise<PromotedCampaignForBrandsResponse[]>;

    /**
     * @param campaignCode The Campaign Code
     * @return The OK response
     */
    campaignBycode(campaignCode: string): Promise<NonPromotedCampaignsResponse>;

    /**
     * @return The OK response
     */
    healthAvailability(): Promise<boolean>;

    /**
     * @return The OK response
     */
    healthWarmup(): Promise<boolean>;

    /**
     * @return The OK response
     */
    healthFrontdoor(): Promise<boolean>;

    /**
     * @return The OK response
     */
    healthClock(): Promise<any>;

    /**
     * @return The OK response
     */
    preferences(): Promise<PreferenceResponse[]>;

    /**
     * @return The OK response
     */
    preferencesAll(): Promise<BagSelectorPreferenceResponse[]>;

    /**
     * @return The OK response
     */
    preferencesProductCollection(): Promise<PreferenceProductCollectionProductResponse[]>;

    /**
     * @return The OK response
     */
    productsAll(): Promise<WebsiteProductsResponse>;

    /**
     * @param sku The product SKU
     * @return The OK response
     */
    productsByskuAddonsActive(sku: string): Promise<ProductOptionStockAvailability[]>;

    /**
     * @return The OK response
     */
    productsAllAddonsActive(): Promise<ProductOptionStockAvailability[]>;

    /**
     * @param skus The product SKUs separated by comma
     * @return The OK response
     */
    productsStockByskusAvailability(skus: string): Promise<ProductStockAvailabilityResponse[]>;

    /**
     * @param sku The product SKU
     * @param week The delivery week (a Sunday) in the format WYYYY-MM-DD
     * @return The OK response
     */
    productsByskuweekDetails(sku: string, week: string): Promise<WebsiteProductDetailsResponse>;

    /**
     * @param code The promo code
     * @return The OK response. IsValid is false when the code is unknown or expired.
     */
    promoBycode(code: string): Promise<WebsitePromoResponse>;
}

export class WebsiteApiClient extends ApiClientBase implements IWebsiteApiClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IApiClientConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:7043";
    }

    /**
     * @return The OK response
     */
    campaignPromoted(): Promise<PromotedCampaignForBrandsResponse[]> {
        let url_ = this.baseUrl + "/campaign/promoted";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCampaignPromoted(_response);
        });
    }

    protected processCampaignPromoted(response: Response): Promise<PromotedCampaignForBrandsResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PromotedCampaignForBrandsResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PromotedCampaignForBrandsResponse[]>(null as any);
    }

    /**
     * @param campaignCode The Campaign Code
     * @return The OK response
     */
    campaignBycode(campaignCode: string): Promise<NonPromotedCampaignsResponse> {
        let url_ = this.baseUrl + "/campaign/bycode/{campaignCode}";
        if (campaignCode === undefined || campaignCode === null)
            throw new Error("The parameter 'campaignCode' must be defined.");
        url_ = url_.replace("{campaignCode}", encodeURIComponent("" + campaignCode));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCampaignBycode(_response);
        });
    }

    protected processCampaignBycode(response: Response): Promise<NonPromotedCampaignsResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NonPromotedCampaignsResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NonPromotedCampaignsResponse>(null as any);
    }

    /**
     * @return The OK response
     */
    healthAvailability(): Promise<boolean> {
        let url_ = this.baseUrl + "/_health/availability";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processHealthAvailability(_response);
        });
    }

    protected processHealthAvailability(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @return The OK response
     */
    healthWarmup(): Promise<boolean> {
        let url_ = this.baseUrl + "/_health/warmup";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processHealthWarmup(_response);
        });
    }

    protected processHealthWarmup(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @return The OK response
     */
    healthFrontdoor(): Promise<boolean> {
        let url_ = this.baseUrl + "/_health/frontdoor";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processHealthFrontdoor(_response);
        });
    }

    protected processHealthFrontdoor(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @return The OK response
     */
    healthClock(): Promise<any> {
        let url_ = this.baseUrl + "/_health/clock";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processHealthClock(_response);
        });
    }

    protected processHealthClock(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(null as any);
    }

    /**
     * @return The OK response
     */
    preferences(): Promise<PreferenceResponse[]> {
        let url_ = this.baseUrl + "/preferences";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPreferences(_response);
        });
    }

    protected processPreferences(response: Response): Promise<PreferenceResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PreferenceResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PreferenceResponse[]>(null as any);
    }

    /**
     * @return The OK response
     */
    preferencesAll(): Promise<BagSelectorPreferenceResponse[]> {
        let url_ = this.baseUrl + "/preferences/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPreferencesAll(_response);
        });
    }

    protected processPreferencesAll(response: Response): Promise<BagSelectorPreferenceResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BagSelectorPreferenceResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BagSelectorPreferenceResponse[]>(null as any);
    }

    /**
     * @return The OK response
     */
    preferencesProductCollection(): Promise<PreferenceProductCollectionProductResponse[]> {
        let url_ = this.baseUrl + "/preferences/productCollection";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPreferencesProductCollection(_response);
        });
    }

    protected processPreferencesProductCollection(response: Response): Promise<PreferenceProductCollectionProductResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PreferenceProductCollectionProductResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PreferenceProductCollectionProductResponse[]>(null as any);
    }

    /**
     * @return The OK response
     */
    productsAll(): Promise<WebsiteProductsResponse> {
        let url_ = this.baseUrl + "/products/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processProductsAll(_response);
        });
    }

    protected processProductsAll(response: Response): Promise<WebsiteProductsResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WebsiteProductsResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WebsiteProductsResponse>(null as any);
    }

    /**
     * @param sku The product SKU
     * @return The OK response
     */
    productsByskuAddonsActive(sku: string): Promise<ProductOptionStockAvailability[]> {
        let url_ = this.baseUrl + "/products/bysku/{sku}/addons/active";
        if (sku === undefined || sku === null)
            throw new Error("The parameter 'sku' must be defined.");
        url_ = url_.replace("{sku}", encodeURIComponent("" + sku));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processProductsByskuAddonsActive(_response);
        });
    }

    protected processProductsByskuAddonsActive(response: Response): Promise<ProductOptionStockAvailability[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProductOptionStockAvailability.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProductOptionStockAvailability[]>(null as any);
    }

    /**
     * @return The OK response
     */
    productsAllAddonsActive(): Promise<ProductOptionStockAvailability[]> {
        let url_ = this.baseUrl + "/products/all/addons/active";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processProductsAllAddonsActive(_response);
        });
    }

    protected processProductsAllAddonsActive(response: Response): Promise<ProductOptionStockAvailability[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProductOptionStockAvailability.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProductOptionStockAvailability[]>(null as any);
    }

    /**
     * @param skus The product SKUs separated by comma
     * @return The OK response
     */
    productsStockByskusAvailability(skus: string): Promise<ProductStockAvailabilityResponse[]> {
        let url_ = this.baseUrl + "/products/stock/byskus/{skus}/availability";
        if (skus === undefined || skus === null)
            throw new Error("The parameter 'skus' must be defined.");
        url_ = url_.replace("{skus}", encodeURIComponent("" + skus));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processProductsStockByskusAvailability(_response);
        });
    }

    protected processProductsStockByskusAvailability(response: Response): Promise<ProductStockAvailabilityResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProductStockAvailabilityResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProductStockAvailabilityResponse[]>(null as any);
    }

    /**
     * @param sku The product SKU
     * @param week The delivery week (a Sunday) in the format WYYYY-MM-DD
     * @return The OK response
     */
    productsByskuweekDetails(sku: string, week: string): Promise<WebsiteProductDetailsResponse> {
        let url_ = this.baseUrl + "/products/byskuweek/{sku}/{week}/details";
        if (sku === undefined || sku === null)
            throw new Error("The parameter 'sku' must be defined.");
        url_ = url_.replace("{sku}", encodeURIComponent("" + sku));
        if (week === undefined || week === null)
            throw new Error("The parameter 'week' must be defined.");
        url_ = url_.replace("{week}", encodeURIComponent("" + week));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processProductsByskuweekDetails(_response);
        });
    }

    protected processProductsByskuweekDetails(response: Response): Promise<WebsiteProductDetailsResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WebsiteProductDetailsResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WebsiteProductDetailsResponse>(null as any);
    }

    /**
     * @param code The promo code
     * @return The OK response. IsValid is false when the code is unknown or expired.
     */
    promoBycode(code: string): Promise<WebsitePromoResponse> {
        let url_ = this.baseUrl + "/promo/bycode/{code}";
        if (code === undefined || code === null)
            throw new Error("The parameter 'code' must be defined.");
        url_ = url_.replace("{code}", encodeURIComponent("" + code));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPromoBycode(_response);
        });
    }

    protected processPromoBycode(response: Response): Promise<WebsitePromoResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WebsitePromoResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WebsitePromoResponse>(null as any);
    }
}

export class BadgeResponse implements IBadgeResponse {
    description?: string | undefined;
    hex?: string | undefined;

    constructor(data?: IBadgeResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"];
            this.hex = _data["hex"];
        }
    }

    static fromJS(data: any): BadgeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new BadgeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["hex"] = this.hex;
        return data;
    }
}

export interface IBadgeResponse {
    description?: string | undefined;
    hex?: string | undefined;
}

export class BagSelectorPreferenceResponse implements IBagSelectorPreferenceResponse {
    preferenceId!: number;
    preferenceCode!: string;
    displayName?: string | undefined;
    description?: string | undefined;
    shortName!: string;
    iconSvgUrl?: string | undefined;
    iconPngUrl?: string | undefined;
    isVisible!: boolean;
    brand!: MfbBrandEnum;
    sortOrder!: number;
    defaultProductCollectionCode!: string;
    displayGroup!: string;
    childPreferences!: BagSelectorPreferenceResponse[];
    filters?: FiltersRecipeResponse[] | undefined;

    constructor(data?: IBagSelectorPreferenceResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.childPreferences = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.preferenceId = _data["preferenceId"];
            this.preferenceCode = _data["preferenceCode"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
            this.shortName = _data["shortName"];
            this.iconSvgUrl = _data["iconSvgUrl"];
            this.iconPngUrl = _data["iconPngUrl"];
            this.isVisible = _data["isVisible"];
            this.brand = _data["brand"];
            this.sortOrder = _data["sortOrder"];
            this.defaultProductCollectionCode = _data["defaultProductCollectionCode"];
            this.displayGroup = _data["displayGroup"];
            if (Array.isArray(_data["childPreferences"])) {
                this.childPreferences = [] as any;
                for (let item of _data["childPreferences"])
                    this.childPreferences!.push(BagSelectorPreferenceResponse.fromJS(item));
            }
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(FiltersRecipeResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BagSelectorPreferenceResponse {
        data = typeof data === 'object' ? data : {};
        let result = new BagSelectorPreferenceResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["preferenceId"] = this.preferenceId;
        data["preferenceCode"] = this.preferenceCode;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["shortName"] = this.shortName;
        data["iconSvgUrl"] = this.iconSvgUrl;
        data["iconPngUrl"] = this.iconPngUrl;
        data["isVisible"] = this.isVisible;
        data["brand"] = this.brand;
        data["sortOrder"] = this.sortOrder;
        data["defaultProductCollectionCode"] = this.defaultProductCollectionCode;
        data["displayGroup"] = this.displayGroup;
        if (Array.isArray(this.childPreferences)) {
            data["childPreferences"] = [];
            for (let item of this.childPreferences)
                data["childPreferences"].push(item.toJSON());
        }
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item.toJSON());
        }
        return data;
    }
}

export interface IBagSelectorPreferenceResponse {
    preferenceId: number;
    preferenceCode: string;
    displayName?: string | undefined;
    description?: string | undefined;
    shortName: string;
    iconSvgUrl?: string | undefined;
    iconPngUrl?: string | undefined;
    isVisible: boolean;
    brand: MfbBrandEnum;
    sortOrder: number;
    defaultProductCollectionCode: string;
    displayGroup: string;
    childPreferences: BagSelectorPreferenceResponse[];
    filters?: FiltersRecipeResponse[] | undefined;
}

export class FiltersRecipeResponse implements IFiltersRecipeResponse {
    filterCode?: string | undefined;
    filterDisplay?: string | undefined;
    sortOrder?: number | undefined;
    resultCount?: number | undefined;
    items?: RecipeItemResponse[] | undefined;

    constructor(data?: IFiltersRecipeResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filterCode = _data["filterCode"];
            this.filterDisplay = _data["filterDisplay"];
            this.sortOrder = _data["sortOrder"];
            this.resultCount = _data["resultCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(RecipeItemResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FiltersRecipeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new FiltersRecipeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filterCode"] = this.filterCode;
        data["filterDisplay"] = this.filterDisplay;
        data["sortOrder"] = this.sortOrder;
        data["resultCount"] = this.resultCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFiltersRecipeResponse {
    filterCode?: string | undefined;
    filterDisplay?: string | undefined;
    sortOrder?: number | undefined;
    resultCount?: number | undefined;
    items?: RecipeItemResponse[] | undefined;
}

export class FiltersResponse implements IFiltersResponse {
    recipes?: FiltersRecipeResponse[] | undefined;

    constructor(data?: IFiltersResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["recipes"])) {
                this.recipes = [] as any;
                for (let item of _data["recipes"])
                    this.recipes!.push(FiltersRecipeResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FiltersResponse {
        data = typeof data === 'object' ? data : {};
        let result = new FiltersResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.recipes)) {
            data["recipes"] = [];
            for (let item of this.recipes)
                data["recipes"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFiltersResponse {
    recipes?: FiltersRecipeResponse[] | undefined;
}

export class IngredientGroupResponse implements IIngredientGroupResponse {
    name?: string | undefined;
    ingredients?: IngredientResponse[] | undefined;

    constructor(data?: IIngredientGroupResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            if (Array.isArray(_data["ingredients"])) {
                this.ingredients = [] as any;
                for (let item of _data["ingredients"])
                    this.ingredients!.push(IngredientResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): IngredientGroupResponse {
        data = typeof data === 'object' ? data : {};
        let result = new IngredientGroupResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (Array.isArray(this.ingredients)) {
            data["ingredients"] = [];
            for (let item of this.ingredients)
                data["ingredients"].push(item.toJSON());
        }
        return data;
    }
}

export interface IIngredientGroupResponse {
    name?: string | undefined;
    ingredients?: IngredientResponse[] | undefined;
}

export class IngredientResponse implements IIngredientResponse {
    ingredientType?: IngredientResponseIngredientType | undefined;
    description?: string | undefined;
    allergensContains?: string | undefined;
    allergensMayContain?: string | undefined;

    constructor(data?: IIngredientResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.ingredientType = IngredientResponseIngredientType._0;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ingredientType = _data["ingredientType"] !== undefined ? _data["ingredientType"] : IngredientResponseIngredientType._0;
            this.description = _data["description"];
            this.allergensContains = _data["allergensContains"];
            this.allergensMayContain = _data["allergensMayContain"];
        }
    }

    static fromJS(data: any): IngredientResponse {
        data = typeof data === 'object' ? data : {};
        let result = new IngredientResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ingredientType"] = this.ingredientType;
        data["description"] = this.description;
        data["allergensContains"] = this.allergensContains;
        data["allergensMayContain"] = this.allergensMayContain;
        return data;
    }
}

export interface IIngredientResponse {
    ingredientType?: IngredientResponseIngredientType | undefined;
    description?: string | undefined;
    allergensContains?: string | undefined;
    allergensMayContain?: string | undefined;
}

export class NonPromotedCampaignsResponse implements INonPromotedCampaignsResponse {
    isValidCampaign!: boolean;
    joinTitle!: string;
    joinDescription!: string;
    eligibleBrands!: string[];
    brand!: string;
    campaignCode!: string;

    constructor(data?: INonPromotedCampaignsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.eligibleBrands = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isValidCampaign = _data["isValidCampaign"];
            this.joinTitle = _data["joinTitle"];
            this.joinDescription = _data["joinDescription"];
            if (Array.isArray(_data["eligibleBrands"])) {
                this.eligibleBrands = [] as any;
                for (let item of _data["eligibleBrands"])
                    this.eligibleBrands!.push(item);
            }
            this.brand = _data["brand"];
            this.campaignCode = _data["campaignCode"];
        }
    }

    static fromJS(data: any): NonPromotedCampaignsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new NonPromotedCampaignsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isValidCampaign"] = this.isValidCampaign;
        data["joinTitle"] = this.joinTitle;
        data["joinDescription"] = this.joinDescription;
        if (Array.isArray(this.eligibleBrands)) {
            data["eligibleBrands"] = [];
            for (let item of this.eligibleBrands)
                data["eligibleBrands"].push(item);
        }
        data["brand"] = this.brand;
        data["campaignCode"] = this.campaignCode;
        return data;
    }
}

export interface INonPromotedCampaignsResponse {
    isValidCampaign: boolean;
    joinTitle: string;
    joinDescription: string;
    eligibleBrands: string[];
    brand: string;
    campaignCode: string;
}

export class NutritionResponse implements INutritionResponse {
    code?: string | undefined;
    label?: string | undefined;
    value?: number | undefined;
    unit?: string | undefined;

    constructor(data?: INutritionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.label = _data["label"];
            this.value = _data["value"];
            this.unit = _data["unit"];
        }
    }

    static fromJS(data: any): NutritionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new NutritionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["label"] = this.label;
        data["value"] = this.value;
        data["unit"] = this.unit;
        return data;
    }
}

export interface INutritionResponse {
    code?: string | undefined;
    label?: string | undefined;
    value?: number | undefined;
    unit?: string | undefined;
}

export class PreferenceProductCollectionProductResponse implements IPreferenceProductCollectionProductResponse {
    code?: string | undefined;
    sku?: string | undefined;
    historicalSku?: string | undefined;
    brand?: string | undefined;

    constructor(data?: IPreferenceProductCollectionProductResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.sku = _data["sku"];
            this.historicalSku = _data["historicalSku"];
            this.brand = _data["brand"];
        }
    }

    static fromJS(data: any): PreferenceProductCollectionProductResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PreferenceProductCollectionProductResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["sku"] = this.sku;
        data["historicalSku"] = this.historicalSku;
        data["brand"] = this.brand;
        return data;
    }
}

export interface IPreferenceProductCollectionProductResponse {
    code?: string | undefined;
    sku?: string | undefined;
    historicalSku?: string | undefined;
    brand?: string | undefined;
}

export class PreferenceResponse implements IPreferenceResponse {
    preferenceId?: number | undefined;
    preferenceName?: string | undefined;
    displayName?: string | undefined;
    description?: string | undefined;
    iconSvg?: string | undefined;
    iconPng?: string | undefined;
    brand?: string | undefined;
    brandShortCode?: string | undefined;
    sortOrder?: number | undefined;
    brandHero?: string | undefined;
    defaultProductCollectionCode?: string | undefined;
    filters?: FiltersResponse[] | undefined;

    constructor(data?: IPreferenceResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.preferenceId = _data["preferenceId"];
            this.preferenceName = _data["preferenceName"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
            this.iconSvg = _data["iconSvg"];
            this.iconPng = _data["iconPng"];
            this.brand = _data["brand"];
            this.brandShortCode = _data["brandShortCode"];
            this.sortOrder = _data["sortOrder"];
            this.brandHero = _data["brandHero"];
            this.defaultProductCollectionCode = _data["defaultProductCollectionCode"];
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(FiltersResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PreferenceResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PreferenceResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["preferenceId"] = this.preferenceId;
        data["preferenceName"] = this.preferenceName;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["iconSvg"] = this.iconSvg;
        data["iconPng"] = this.iconPng;
        data["brand"] = this.brand;
        data["brandShortCode"] = this.brandShortCode;
        data["sortOrder"] = this.sortOrder;
        data["brandHero"] = this.brandHero;
        data["defaultProductCollectionCode"] = this.defaultProductCollectionCode;
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPreferenceResponse {
    preferenceId?: number | undefined;
    preferenceName?: string | undefined;
    displayName?: string | undefined;
    description?: string | undefined;
    iconSvg?: string | undefined;
    iconPng?: string | undefined;
    brand?: string | undefined;
    brandShortCode?: string | undefined;
    sortOrder?: number | undefined;
    brandHero?: string | undefined;
    defaultProductCollectionCode?: string | undefined;
    filters?: FiltersResponse[] | undefined;
}

export class PrimaryProductInfo implements IPrimaryProductInfo {
    primarySku?: string | undefined;
    historicSku?: string | undefined;

    constructor(data?: IPrimaryProductInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.primarySku = _data["primarySku"];
            this.historicSku = _data["historicSku"];
        }
    }

    static fromJS(data: any): PrimaryProductInfo {
        data = typeof data === 'object' ? data : {};
        let result = new PrimaryProductInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["primarySku"] = this.primarySku;
        data["historicSku"] = this.historicSku;
        return data;
    }
}

export interface IPrimaryProductInfo {
    primarySku?: string | undefined;
    historicSku?: string | undefined;
}

export class ProductOptionStockAvailability implements IProductOptionStockAvailability {
    addOnSku?: string | undefined;
    addOnHistoricSku?: string | undefined;
    primaryProductInfo?: PrimaryProductInfo[] | undefined;
    marketingTitle?: string | undefined;
    marketingDescription?: string | undefined;
    recipeImage?: string | undefined;
    hasStockAvailable?: boolean | undefined;
    hasUnlimitedBufferStock?: boolean | undefined;
    numberOfPeopleToFeed?: number | undefined;
    numberOfNights?: number | undefined;
    active?: boolean | undefined;

    constructor(data?: IProductOptionStockAvailability) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.addOnSku = _data["addOnSku"];
            this.addOnHistoricSku = _data["addOnHistoricSku"];
            if (Array.isArray(_data["primaryProductInfo"])) {
                this.primaryProductInfo = [] as any;
                for (let item of _data["primaryProductInfo"])
                    this.primaryProductInfo!.push(PrimaryProductInfo.fromJS(item));
            }
            this.marketingTitle = _data["marketingTitle"];
            this.marketingDescription = _data["marketingDescription"];
            this.recipeImage = _data["recipeImage"];
            this.hasStockAvailable = _data["hasStockAvailable"];
            this.hasUnlimitedBufferStock = _data["hasUnlimitedBufferStock"];
            this.numberOfPeopleToFeed = _data["numberOfPeopleToFeed"];
            this.numberOfNights = _data["numberOfNights"];
            this.active = _data["active"];
        }
    }

    static fromJS(data: any): ProductOptionStockAvailability {
        data = typeof data === 'object' ? data : {};
        let result = new ProductOptionStockAvailability();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["addOnSku"] = this.addOnSku;
        data["addOnHistoricSku"] = this.addOnHistoricSku;
        if (Array.isArray(this.primaryProductInfo)) {
            data["primaryProductInfo"] = [];
            for (let item of this.primaryProductInfo)
                data["primaryProductInfo"].push(item.toJSON());
        }
        data["marketingTitle"] = this.marketingTitle;
        data["marketingDescription"] = this.marketingDescription;
        data["recipeImage"] = this.recipeImage;
        data["hasStockAvailable"] = this.hasStockAvailable;
        data["hasUnlimitedBufferStock"] = this.hasUnlimitedBufferStock;
        data["numberOfPeopleToFeed"] = this.numberOfPeopleToFeed;
        data["numberOfNights"] = this.numberOfNights;
        data["active"] = this.active;
        return data;
    }
}

export interface IProductOptionStockAvailability {
    addOnSku?: string | undefined;
    addOnHistoricSku?: string | undefined;
    primaryProductInfo?: PrimaryProductInfo[] | undefined;
    marketingTitle?: string | undefined;
    marketingDescription?: string | undefined;
    recipeImage?: string | undefined;
    hasStockAvailable?: boolean | undefined;
    hasUnlimitedBufferStock?: boolean | undefined;
    numberOfPeopleToFeed?: number | undefined;
    numberOfNights?: number | undefined;
    active?: boolean | undefined;
}

export class ProductStockAvailabilityResponse implements IProductStockAvailabilityResponse {
    sku!: string;
    itemNumber!: string;
    hasStockAvailable!: boolean;

    constructor(data?: IProductStockAvailabilityResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sku = _data["sku"];
            this.itemNumber = _data["itemNumber"];
            this.hasStockAvailable = _data["hasStockAvailable"];
        }
    }

    static fromJS(data: any): ProductStockAvailabilityResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ProductStockAvailabilityResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sku"] = this.sku;
        data["itemNumber"] = this.itemNumber;
        data["hasStockAvailable"] = this.hasStockAvailable;
        return data;
    }
}

export interface IProductStockAvailabilityResponse {
    sku: string;
    itemNumber: string;
    hasStockAvailable: boolean;
}

export class PromotedCampaignForBrandsResponse implements IPromotedCampaignForBrandsResponse {
    joinTitle?: string | undefined;
    joinDescription?: string | undefined;
    brand?: string | undefined;
    campaignCode?: string | undefined;

    constructor(data?: IPromotedCampaignForBrandsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.joinTitle = _data["joinTitle"];
            this.joinDescription = _data["joinDescription"];
            this.brand = _data["brand"];
            this.campaignCode = _data["campaignCode"];
        }
    }

    static fromJS(data: any): PromotedCampaignForBrandsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PromotedCampaignForBrandsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["joinTitle"] = this.joinTitle;
        data["joinDescription"] = this.joinDescription;
        data["brand"] = this.brand;
        data["campaignCode"] = this.campaignCode;
        return data;
    }
}

export interface IPromotedCampaignForBrandsResponse {
    joinTitle?: string | undefined;
    joinDescription?: string | undefined;
    brand?: string | undefined;
    campaignCode?: string | undefined;
}

export class RecipeItemResponse implements IRecipeItemResponse {
    itemNumber?: string | undefined;
    sortOrder?: number | undefined;

    constructor(data?: IRecipeItemResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.itemNumber = _data["itemNumber"];
            this.sortOrder = _data["sortOrder"];
        }
    }

    static fromJS(data: any): RecipeItemResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RecipeItemResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["itemNumber"] = this.itemNumber;
        data["sortOrder"] = this.sortOrder;
        return data;
    }
}

export interface IRecipeItemResponse {
    itemNumber?: string | undefined;
    sortOrder?: number | undefined;
}

export class RecipeSurchargeResponse implements IRecipeSurchargeResponse {
    listPrice?: number | undefined;
    salePrice?: number | undefined;
    hasDiscount?: boolean | undefined;

    constructor(data?: IRecipeSurchargeResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.listPrice = _data["listPrice"];
            this.salePrice = _data["salePrice"];
            this.hasDiscount = _data["hasDiscount"];
        }
    }

    static fromJS(data: any): RecipeSurchargeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RecipeSurchargeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["listPrice"] = this.listPrice;
        data["salePrice"] = this.salePrice;
        data["hasDiscount"] = this.hasDiscount;
        return data;
    }
}

export interface IRecipeSurchargeResponse {
    listPrice?: number | undefined;
    salePrice?: number | undefined;
    hasDiscount?: boolean | undefined;
}

export class StepResponse implements IStepResponse {
    number?: number | undefined;
    heading?: string | undefined;
    methods?: string | undefined;

    constructor(data?: IStepResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.number = _data["number"];
            this.heading = _data["heading"];
            this.methods = _data["methods"];
        }
    }

    static fromJS(data: any): StepResponse {
        data = typeof data === 'object' ? data : {};
        let result = new StepResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["number"] = this.number;
        data["heading"] = this.heading;
        data["methods"] = this.methods;
        return data;
    }
}

export interface IStepResponse {
    number?: number | undefined;
    heading?: string | undefined;
    methods?: string | undefined;
}

export class WebsiteAddProductBenefitResponse implements IWebsiteAddProductBenefitResponse {
    product?: WebsitePromoProductResponse | undefined;
    overridePrice?: number | undefined;

    constructor(data?: IWebsiteAddProductBenefitResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.product = _data["product"] ? WebsitePromoProductResponse.fromJS(_data["product"]) : <any>undefined;
            this.overridePrice = _data["overridePrice"];
        }
    }

    static fromJS(data: any): WebsiteAddProductBenefitResponse {
        data = typeof data === 'object' ? data : {};
        let result = new WebsiteAddProductBenefitResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["product"] = this.product ? this.product.toJSON() : <any>undefined;
        data["overridePrice"] = this.overridePrice;
        return data;
    }
}

export interface IWebsiteAddProductBenefitResponse {
    product?: WebsitePromoProductResponse | undefined;
    overridePrice?: number | undefined;
}

export class WebsitePriceBenefitResponse implements IWebsitePriceBenefitResponse {
    benefitType?: string | undefined;
    benefitValue?: number | undefined;
    selector?: string | undefined;
    productSelectorType?: string | undefined;

    constructor(data?: IWebsitePriceBenefitResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.benefitType = _data["benefitType"];
            this.benefitValue = _data["benefitValue"];
            this.selector = _data["selector"];
            this.productSelectorType = _data["productSelectorType"];
        }
    }

    static fromJS(data: any): WebsitePriceBenefitResponse {
        data = typeof data === 'object' ? data : {};
        let result = new WebsitePriceBenefitResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["benefitType"] = this.benefitType;
        data["benefitValue"] = this.benefitValue;
        data["selector"] = this.selector;
        data["productSelectorType"] = this.productSelectorType;
        return data;
    }
}

export interface IWebsitePriceBenefitResponse {
    benefitType?: string | undefined;
    benefitValue?: number | undefined;
    selector?: string | undefined;
    productSelectorType?: string | undefined;
}

export class WebsiteProductDetailsResponse implements IWebsiteProductDetailsResponse {
    sku?: string | undefined;
    name?: string | undefined;
    week?: string | undefined;
    childRecipesCollection?: WebsiteRecipeResponse[] | undefined;

    constructor(data?: IWebsiteProductDetailsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sku = _data["sku"];
            this.name = _data["name"];
            this.week = _data["week"];
            if (Array.isArray(_data["childRecipesCollection"])) {
                this.childRecipesCollection = [] as any;
                for (let item of _data["childRecipesCollection"])
                    this.childRecipesCollection!.push(WebsiteRecipeResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): WebsiteProductDetailsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new WebsiteProductDetailsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sku"] = this.sku;
        data["name"] = this.name;
        data["week"] = this.week;
        if (Array.isArray(this.childRecipesCollection)) {
            data["childRecipesCollection"] = [];
            for (let item of this.childRecipesCollection)
                data["childRecipesCollection"].push(item.toJSON());
        }
        return data;
    }
}

export interface IWebsiteProductDetailsResponse {
    sku?: string | undefined;
    name?: string | undefined;
    week?: string | undefined;
    childRecipesCollection?: WebsiteRecipeResponse[] | undefined;
}

export class WebsiteProductResponse implements IWebsiteProductResponse {
    sku!: string;
    itemNumber!: string;
    productName!: string;
    productType!: MfbProductTypeEnum;
    brand!: MfbBrandEnum;
    availableFrequencies!: MfbFrequencyEnum[];
    numberOfPeopleToFeed?: number | undefined;
    numberOfNights?: number | undefined;
    recipeSelectionMode!: MfbRecipeSelectionModeEnum;
    price?: number | undefined;
    deliveryPrice?: number | undefined;
    hasPreferences!: boolean;

    constructor(data?: IWebsiteProductResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.availableFrequencies = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sku = _data["sku"];
            this.itemNumber = _data["itemNumber"];
            this.productName = _data["productName"];
            this.productType = _data["productType"];
            this.brand = _data["brand"];
            if (Array.isArray(_data["availableFrequencies"])) {
                this.availableFrequencies = [] as any;
                for (let item of _data["availableFrequencies"])
                    this.availableFrequencies!.push(item);
            }
            this.numberOfPeopleToFeed = _data["numberOfPeopleToFeed"];
            this.numberOfNights = _data["numberOfNights"];
            this.recipeSelectionMode = _data["recipeSelectionMode"];
            this.price = _data["price"];
            this.deliveryPrice = _data["deliveryPrice"];
            this.hasPreferences = _data["hasPreferences"];
        }
    }

    static fromJS(data: any): WebsiteProductResponse {
        data = typeof data === 'object' ? data : {};
        let result = new WebsiteProductResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sku"] = this.sku;
        data["itemNumber"] = this.itemNumber;
        data["productName"] = this.productName;
        data["productType"] = this.productType;
        data["brand"] = this.brand;
        if (Array.isArray(this.availableFrequencies)) {
            data["availableFrequencies"] = [];
            for (let item of this.availableFrequencies)
                data["availableFrequencies"].push(item);
        }
        data["numberOfPeopleToFeed"] = this.numberOfPeopleToFeed;
        data["numberOfNights"] = this.numberOfNights;
        data["recipeSelectionMode"] = this.recipeSelectionMode;
        data["price"] = this.price;
        data["deliveryPrice"] = this.deliveryPrice;
        data["hasPreferences"] = this.hasPreferences;
        return data;
    }
}

export interface IWebsiteProductResponse {
    sku: string;
    itemNumber: string;
    productName: string;
    productType: MfbProductTypeEnum;
    brand: MfbBrandEnum;
    availableFrequencies: MfbFrequencyEnum[];
    numberOfPeopleToFeed?: number | undefined;
    numberOfNights?: number | undefined;
    recipeSelectionMode: MfbRecipeSelectionModeEnum;
    price?: number | undefined;
    deliveryPrice?: number | undefined;
    hasPreferences: boolean;
}

export class WebsiteProductsResponse implements IWebsiteProductsResponse {
    products!: WebsiteProductResponse[];

    constructor(data?: IWebsiteProductsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.products = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["products"])) {
                this.products = [] as any;
                for (let item of _data["products"])
                    this.products!.push(WebsiteProductResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): WebsiteProductsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new WebsiteProductsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.products)) {
            data["products"] = [];
            for (let item of this.products)
                data["products"].push(item.toJSON());
        }
        return data;
    }
}

export interface IWebsiteProductsResponse {
    products: WebsiteProductResponse[];
}

export class WebsitePromoBenefitResponse implements IWebsitePromoBenefitResponse {
    message?: string | undefined;
    consumableFrom?: Date | undefined;
    consumableTo?: Date | undefined;
    priceBenefits?: WebsitePriceBenefitResponse[] | undefined;
    addProductBenefits?: WebsiteAddProductBenefitResponse[] | undefined;

    constructor(data?: IWebsitePromoBenefitResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"];
            this.consumableFrom = _data["consumableFrom"] ? new Date(_data["consumableFrom"].toString()) : <any>undefined;
            this.consumableTo = _data["consumableTo"] ? new Date(_data["consumableTo"].toString()) : <any>undefined;
            if (Array.isArray(_data["priceBenefits"])) {
                this.priceBenefits = [] as any;
                for (let item of _data["priceBenefits"])
                    this.priceBenefits!.push(WebsitePriceBenefitResponse.fromJS(item));
            }
            if (Array.isArray(_data["addProductBenefits"])) {
                this.addProductBenefits = [] as any;
                for (let item of _data["addProductBenefits"])
                    this.addProductBenefits!.push(WebsiteAddProductBenefitResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): WebsitePromoBenefitResponse {
        data = typeof data === 'object' ? data : {};
        let result = new WebsitePromoBenefitResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        data["consumableFrom"] = this.consumableFrom ? this.consumableFrom.toISOString() : <any>undefined;
        data["consumableTo"] = this.consumableTo ? this.consumableTo.toISOString() : <any>undefined;
        if (Array.isArray(this.priceBenefits)) {
            data["priceBenefits"] = [];
            for (let item of this.priceBenefits)
                data["priceBenefits"].push(item.toJSON());
        }
        if (Array.isArray(this.addProductBenefits)) {
            data["addProductBenefits"] = [];
            for (let item of this.addProductBenefits)
                data["addProductBenefits"].push(item.toJSON());
        }
        return data;
    }
}

export interface IWebsitePromoBenefitResponse {
    message?: string | undefined;
    consumableFrom?: Date | undefined;
    consumableTo?: Date | undefined;
    priceBenefits?: WebsitePriceBenefitResponse[] | undefined;
    addProductBenefits?: WebsiteAddProductBenefitResponse[] | undefined;
}

export class WebsitePromoProductResponse implements IWebsitePromoProductResponse {
    name?: string | undefined;
    sku?: string | undefined;
    itemNumber?: string | undefined;
    numberOfPlates?: number | undefined;

    constructor(data?: IWebsitePromoProductResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.sku = _data["sku"];
            this.itemNumber = _data["itemNumber"];
            this.numberOfPlates = _data["numberOfPlates"];
        }
    }

    static fromJS(data: any): WebsitePromoProductResponse {
        data = typeof data === 'object' ? data : {};
        let result = new WebsitePromoProductResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["sku"] = this.sku;
        data["itemNumber"] = this.itemNumber;
        data["numberOfPlates"] = this.numberOfPlates;
        return data;
    }
}

export interface IWebsitePromoProductResponse {
    name?: string | undefined;
    sku?: string | undefined;
    itemNumber?: string | undefined;
    numberOfPlates?: number | undefined;
}

export class WebsitePromoResponse implements IWebsitePromoResponse {
    isValid?: boolean | undefined;
    code?: string | undefined;
    message?: string | undefined;
    forNewOrReturningCustomers?: boolean | undefined;
    redeemableFrom?: Date | undefined;
    redeemableTo?: Date | undefined;
    bannerUrlSmall?: string | undefined;
    bannerUrlMedium?: string | undefined;
    bannerUrlLarge?: string | undefined;
    validForProducts?: WebsitePromoProductResponse[] | undefined;
    benefits?: WebsitePromoBenefitResponse[] | undefined;

    constructor(data?: IWebsitePromoResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isValid = _data["isValid"];
            this.code = _data["code"];
            this.message = _data["message"];
            this.forNewOrReturningCustomers = _data["forNewOrReturningCustomers"];
            this.redeemableFrom = _data["redeemableFrom"] ? new Date(_data["redeemableFrom"].toString()) : <any>undefined;
            this.redeemableTo = _data["redeemableTo"] ? new Date(_data["redeemableTo"].toString()) : <any>undefined;
            this.bannerUrlSmall = _data["bannerUrlSmall"];
            this.bannerUrlMedium = _data["bannerUrlMedium"];
            this.bannerUrlLarge = _data["bannerUrlLarge"];
            if (Array.isArray(_data["validForProducts"])) {
                this.validForProducts = [] as any;
                for (let item of _data["validForProducts"])
                    this.validForProducts!.push(WebsitePromoProductResponse.fromJS(item));
            }
            if (Array.isArray(_data["benefits"])) {
                this.benefits = [] as any;
                for (let item of _data["benefits"])
                    this.benefits!.push(WebsitePromoBenefitResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): WebsitePromoResponse {
        data = typeof data === 'object' ? data : {};
        let result = new WebsitePromoResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isValid"] = this.isValid;
        data["code"] = this.code;
        data["message"] = this.message;
        data["forNewOrReturningCustomers"] = this.forNewOrReturningCustomers;
        data["redeemableFrom"] = this.redeemableFrom ? this.redeemableFrom.toISOString() : <any>undefined;
        data["redeemableTo"] = this.redeemableTo ? this.redeemableTo.toISOString() : <any>undefined;
        data["bannerUrlSmall"] = this.bannerUrlSmall;
        data["bannerUrlMedium"] = this.bannerUrlMedium;
        data["bannerUrlLarge"] = this.bannerUrlLarge;
        if (Array.isArray(this.validForProducts)) {
            data["validForProducts"] = [];
            for (let item of this.validForProducts)
                data["validForProducts"].push(item.toJSON());
        }
        if (Array.isArray(this.benefits)) {
            data["benefits"] = [];
            for (let item of this.benefits)
                data["benefits"].push(item.toJSON());
        }
        return data;
    }
}

export interface IWebsitePromoResponse {
    isValid?: boolean | undefined;
    code?: string | undefined;
    message?: string | undefined;
    forNewOrReturningCustomers?: boolean | undefined;
    redeemableFrom?: Date | undefined;
    redeemableTo?: Date | undefined;
    bannerUrlSmall?: string | undefined;
    bannerUrlMedium?: string | undefined;
    bannerUrlLarge?: string | undefined;
    validForProducts?: WebsitePromoProductResponse[] | undefined;
    benefits?: WebsitePromoBenefitResponse[] | undefined;
}

export class WebsiteRecipeResponse implements IWebsiteRecipeResponse {
    recipeNumber?: string | undefined;
    recipeVersion?: string | undefined;
    recipePartition?: string | undefined;
    title?: string | undefined;
    subTitle?: string | undefined;
    description?: string | undefined;
    webImageUrl?: string | undefined;
    webLargeImageUrl?: string | undefined;
    numberOfServesValue?: number | undefined;
    readyInTimeMinutes?: number | undefined;
    consumption?: string | undefined;
    composition?: string | undefined;
    tags?: string[] | undefined;
    allergensContains?: string[] | undefined;
    allergensMayContain?: string[] | undefined;
    ingredientGroups?: IngredientGroupResponse[] | undefined;
    badge?: BadgeResponse[] | undefined;
    preferenceCodes?: string[] | undefined;
    nutritionalInformation?: NutritionResponse[] | undefined;
    sortOrder?: number | undefined;
    isUpsellMeal?: boolean | undefined;
    isHeroRecipe?: boolean | undefined;
    recipeMethods?: StepResponse[] | undefined;
    surcharge?: RecipeSurchargeResponse | undefined;

    constructor(data?: IWebsiteRecipeResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.recipeNumber = _data["recipeNumber"];
            this.recipeVersion = _data["recipeVersion"];
            this.recipePartition = _data["recipePartition"];
            this.title = _data["title"];
            this.subTitle = _data["subTitle"];
            this.description = _data["description"];
            this.webImageUrl = _data["webImageUrl"];
            this.webLargeImageUrl = _data["webLargeImageUrl"];
            this.numberOfServesValue = _data["numberOfServesValue"];
            this.readyInTimeMinutes = _data["readyInTimeMinutes"];
            this.consumption = _data["consumption"];
            this.composition = _data["composition"];
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(item);
            }
            if (Array.isArray(_data["allergensContains"])) {
                this.allergensContains = [] as any;
                for (let item of _data["allergensContains"])
                    this.allergensContains!.push(item);
            }
            if (Array.isArray(_data["allergensMayContain"])) {
                this.allergensMayContain = [] as any;
                for (let item of _data["allergensMayContain"])
                    this.allergensMayContain!.push(item);
            }
            if (Array.isArray(_data["ingredientGroups"])) {
                this.ingredientGroups = [] as any;
                for (let item of _data["ingredientGroups"])
                    this.ingredientGroups!.push(IngredientGroupResponse.fromJS(item));
            }
            if (Array.isArray(_data["badge"])) {
                this.badge = [] as any;
                for (let item of _data["badge"])
                    this.badge!.push(BadgeResponse.fromJS(item));
            }
            if (Array.isArray(_data["preferenceCodes"])) {
                this.preferenceCodes = [] as any;
                for (let item of _data["preferenceCodes"])
                    this.preferenceCodes!.push(item);
            }
            if (Array.isArray(_data["nutritionalInformation"])) {
                this.nutritionalInformation = [] as any;
                for (let item of _data["nutritionalInformation"])
                    this.nutritionalInformation!.push(NutritionResponse.fromJS(item));
            }
            this.sortOrder = _data["sortOrder"];
            this.isUpsellMeal = _data["isUpsellMeal"];
            this.isHeroRecipe = _data["isHeroRecipe"];
            if (Array.isArray(_data["recipeMethods"])) {
                this.recipeMethods = [] as any;
                for (let item of _data["recipeMethods"])
                    this.recipeMethods!.push(StepResponse.fromJS(item));
            }
            this.surcharge = _data["surcharge"] ? RecipeSurchargeResponse.fromJS(_data["surcharge"]) : <any>undefined;
        }
    }

    static fromJS(data: any): WebsiteRecipeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new WebsiteRecipeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["recipeNumber"] = this.recipeNumber;
        data["recipeVersion"] = this.recipeVersion;
        data["recipePartition"] = this.recipePartition;
        data["title"] = this.title;
        data["subTitle"] = this.subTitle;
        data["description"] = this.description;
        data["webImageUrl"] = this.webImageUrl;
        data["webLargeImageUrl"] = this.webLargeImageUrl;
        data["numberOfServesValue"] = this.numberOfServesValue;
        data["readyInTimeMinutes"] = this.readyInTimeMinutes;
        data["consumption"] = this.consumption;
        data["composition"] = this.composition;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        if (Array.isArray(this.allergensContains)) {
            data["allergensContains"] = [];
            for (let item of this.allergensContains)
                data["allergensContains"].push(item);
        }
        if (Array.isArray(this.allergensMayContain)) {
            data["allergensMayContain"] = [];
            for (let item of this.allergensMayContain)
                data["allergensMayContain"].push(item);
        }
        if (Array.isArray(this.ingredientGroups)) {
            data["ingredientGroups"] = [];
            for (let item of this.ingredientGroups)
                data["ingredientGroups"].push(item.toJSON());
        }
        if (Array.isArray(this.badge)) {
            data["badge"] = [];
            for (let item of this.badge)
                data["badge"].push(item.toJSON());
        }
        if (Array.isArray(this.preferenceCodes)) {
            data["preferenceCodes"] = [];
            for (let item of this.preferenceCodes)
                data["preferenceCodes"].push(item);
        }
        if (Array.isArray(this.nutritionalInformation)) {
            data["nutritionalInformation"] = [];
            for (let item of this.nutritionalInformation)
                data["nutritionalInformation"].push(item.toJSON());
        }
        data["sortOrder"] = this.sortOrder;
        data["isUpsellMeal"] = this.isUpsellMeal;
        data["isHeroRecipe"] = this.isHeroRecipe;
        if (Array.isArray(this.recipeMethods)) {
            data["recipeMethods"] = [];
            for (let item of this.recipeMethods)
                data["recipeMethods"].push(item.toJSON());
        }
        data["surcharge"] = this.surcharge ? this.surcharge.toJSON() : <any>undefined;
        return data;
    }
}

export interface IWebsiteRecipeResponse {
    recipeNumber?: string | undefined;
    recipeVersion?: string | undefined;
    recipePartition?: string | undefined;
    title?: string | undefined;
    subTitle?: string | undefined;
    description?: string | undefined;
    webImageUrl?: string | undefined;
    webLargeImageUrl?: string | undefined;
    numberOfServesValue?: number | undefined;
    readyInTimeMinutes?: number | undefined;
    consumption?: string | undefined;
    composition?: string | undefined;
    tags?: string[] | undefined;
    allergensContains?: string[] | undefined;
    allergensMayContain?: string[] | undefined;
    ingredientGroups?: IngredientGroupResponse[] | undefined;
    badge?: BadgeResponse[] | undefined;
    preferenceCodes?: string[] | undefined;
    nutritionalInformation?: NutritionResponse[] | undefined;
    sortOrder?: number | undefined;
    isUpsellMeal?: boolean | undefined;
    isHeroRecipe?: boolean | undefined;
    recipeMethods?: StepResponse[] | undefined;
    surcharge?: RecipeSurchargeResponse | undefined;
}

export enum MfbBrandEnum {
    MyFoodBag = 1,
    BargainBox = 2,
    FreshStart = 4,
    ReadyMadeMeals = 8,
}

export enum MfbProductTypeEnum {
    Primary = 1,
    Extra = 2,
    Donation = 3,
    OneOff = 4,
    Service = 5,
    Promotional = 6,
}

export enum MfbFrequencyEnum {
    Weekly = 1,
    Fortnightly = 2,
    OneOff = 3,
    FourWeekly = 4,
}

export enum MfbRecipeSelectionModeEnum {
    None = 0,
    Single = 1,
    Multiple = 2,
}

export enum IngredientResponseIngredientType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export class WebsiteClientException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isWebsiteClientException = true;

    static isWebsiteClientException(obj: any): obj is WebsiteClientException {
        return obj.isWebsiteClientException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new WebsiteClientException(message, status, response, headers, null);
}

export interface IApiClientConfig {
  applyTransformToRequest: (options: RequestInit) => void;
}

export class ApimClientConfiguration implements IApiClientConfig {
  private _apiKey: string = '';
  private _apiHeader: string = "Ocp-Apim-Subscription-Key";
  private _apiPlatformHeader: string = "x-mfb-platform";
  private _apiPlatformValue: string = '';
  private _apiVersionHeader: string = "x-mfb-app-version";
  private _apiVersionValue: string = '';

  public setApiKey(apiKey: string, platformName: string, appVersion: string): void {
    this._apiKey = apiKey;
    this._apiPlatformValue = platformName;
    this._apiVersionValue = appVersion;
  }

  applyTransformToRequest(options: RequestInit): void {
      const headers = options.headers as Record<string, string> || {};

      headers[this._apiHeader] = this._apiKey;
      headers[this._apiPlatformHeader] = this._apiPlatformValue;
      headers[this._apiVersionHeader] = this._apiVersionValue;
  
      // Reassign the modified headers back to options.headers
      options.headers = headers;
  }
}

export class FunctionAppClientConfiguration implements IApiClientConfig {
  private _apiKey: string = '';
  private _apiHeader: string = "x-functions-key";
  private _apiPlatformHeader: string = "x-mfb-platform";
  private _apiPlatformValue: string = ''
  private _apiVersionHeader: string = "x-mfb-app-version";
  private _apiVersionValue: string = ''
           
  public setApiKey(apiKey: string, platformName: string, appVersion: string): void {
    this._apiKey = apiKey;
    this._apiPlatformValue = platformName;
    this._apiVersionValue = appVersion;
  }
           
  applyTransformToRequest(options: RequestInit): void {
      // Cast headers to a plain object to allow string indexing
      const headers = options.headers as Record<string, string> || {};
  
      headers[this._apiHeader] = this._apiKey;
      headers[this._apiPlatformHeader] = this._apiPlatformValue;
      headers[this._apiVersionHeader] = this._apiVersionValue;
  
      // Reassign the modified headers back to options.headers
      options.headers = headers;
  }
  
}